module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/assessment_achievements/2_72d155b37004f81527a20c642af1e297.png";